/**
 * Recognises "draw it" style messages typed in Ask mode, so the picture starts at once
 * (no model round-trip). Returns { draw: false } or { draw: true, subject } where `subject`
 * is what to draw ('' when the message only says "draw it / this / that").
 */
const LEAD = String.raw`^(?:please\s+)?(?:(?:can|could|would|will)\s+you\s+(?:please\s+)?)?`;
const VERBS = [
  // draw / sketch / paint / visualise / illustrate …
  String.raw`(?:draw|sketch|paint|visuali[sz]e|illustrate|mock\s*up)`,
  // show / make / create / generate / give / render … a picture|image|drawing|visual|rendering|mockup|3d
  String.raw`(?:show|make|create|generate|give|render|produce)\s+(?:me\s+|us\s+)?(?:a|an|the|some|one)?\s*(?:quick\s+)?(?:picture|image|photo|drawing|visual|visuali[sz]ation|render|rendering|mock-?up|sketch|3d)(?:\s+(?:of|for))?`,
  // I want / I'd like (to see) a picture|image|drawing of …
  String.raw`(?:i\s+(?:want|would\s+like|'d\s+like|need)\s+(?:to\s+see\s+)?(?:a|an|the)?\s*(?:picture|image|drawing|visual|rendering|render|mock-?up)(?:\s+(?:of|for))?)`,
  // let me see / I want to see how it looks
  String.raw`(?:(?:let\s+me|i\s+want\s+to|i\s+would\s+like\s+to|i'd\s+like\s+to)\s+see\s+(?:how\s+)?)`,
];
const TRIGGER = new RegExp(`${LEAD}(?:${VERBS.join('|')})`, 'i');
const FILLER = /^(?:me|us|it|this|that|the design|the piece|my idea|one|please|of|for|how|would|will|it would|it'd|looks?|look like|like|now|,|:|-|\s)+/i;
const BARE = /^(?:it|this|that|the design|my idea|the piece|the same|everything|that idea|this idea)?[.!?\s]*$/i;

export function drawIntent(text) {
  const raw = (text || '').trim();
  const m = TRIGGER.exec(raw);
  if (!m) return { draw: false };
  let subject = raw.slice(m[0].length).trim();
  subject = subject.replace(FILLER, '').trim().replace(/^[,:\-–—]\s*/, '').replace(/[.!?\s]+$/, '').trim();
  if (BARE.test(subject) || subject.split(/\s+/).length < 2) subject = '';
  return { draw: true, subject };
}

/** True when the words refer to the customer's own photo/room ("remove the sofa from my photo", "this room with…"). */
export function refersToPhoto(text) {
  return /\b(?:in|from|of|on|to)\s+(?:my|this|the|that)\s+(?:photo|image|picture|room|living room|bedroom|kitchen|space)\b|\b(?:my|this)\s+(?:photo|image|picture|room)\b/i.test(text || '');
}
